import { FunctionComponent, useEffect, useState } from "react";
import * as imports from "./imports";
import { useParams } from "react-router";
import axios from "axios";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import NotFoundPage from "../utils/NotFoundPage";


interface ProgramTemplateProps {

}


const programmName: { [key: string]: string } = {
    bas: 'БАС',
    kodbudushchego: 'Код будущего',
    Iskusstvennyjintellekt: "Искусственный интеллект",
    Demografiya: "Демография"
}

type IType = 'bas' | 'kodbudushchego' | 'Iskusstvennyjintellekt' | 'Demografiya'

const ProgramTemplate: FunctionComponent<ProgramTemplateProps> = () => {
    let { program } = useParams();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const [loading, setLoading] = useState(true)
    const [datas, setData] = useState({})
    useEffect(() => {
        axios.get('https://admin.aversprofi.ru/rest/items/5')
            .then(res => {
                // console.log(res);

                const newData: Record<string, any> = {};

                for (const [key, value] of Object.entries(res.data.object)) {
                    const parsedItems = JSON.parse(value as string);
                    parsedItems.forEach((item: any) => {
                        newData[key] = [...(newData[key] || []), item];
                    });
                }
                const keysProgramm = newData.keys.map((item: any) => {
                    return item.key;
                });

                setData(groupByKeys(keysProgramm, newData));

                setLoading(false);
            });
    }, []);

    function groupByKeys(keys: string[], data: Record<string, any[]>): Record<string, any> {

        const result: Record<string, any> = {};

        keys.forEach(key => {
            result[key] = {};

            Object.keys(data).forEach(dataKey => {
                const filteredData = data[dataKey].filter(item => item.key === key);

                if (dataKey === "online_course") {
                    filteredData.forEach(item => {
                        if (item.modules) {
                            item.modules = JSON.parse(item.modules);
                        }
                    });
                }

                result[key][dataKey] = filteredData.length === 1 && dataKey !== 'dop_info' ? filteredData[0] : filteredData;
            });
        });


        return result;
    }
    if (loading) {
        return <LoadingSpinner />
    } else {
        console.log((datas as any)[program! as IType]);
        return (
            Object.keys(datas).includes(program!) ?
                <>
                    <main className="font-helio">
                        {/* <imports.Titles data={data[program! as IType].titles} /> */}
                        <imports.Titles data={(datas as any)[program! as IType].info_kb} name={(datas as any)[program! as IType].programs_array.name} />

                        {/* <imports.Programs data={data[program! as IType].programs} /> */}
                        <imports.Programs data={{ title: "Онлайн-курсы", slides: (datas as any)[program! as IType].online_course }} />
                        {/* <imports.Trajectories data={data[program! as IType].trajectories} /> */}

                        {(datas as any)[program! as IType].target.text && <imports.Trajectories data={{
                            title: 'Гибкие образовательные траектории',
                            target: (datas as any)[program! as IType].target.text,
                            whocan: { title: 'Кто может обучаться?', values: JSON.parse((datas as any)[program! as IType].who_can_educate.array) },
                            approaches: { title: 'Ключевые подходы', values: JSON.parse((datas as any)[program! as IType].keys.text) }

                        }} />}
                        {/* <imports.Advantages data={data[program! as IType].advantages} /> */}
                        {JSON.parse((datas as any)[program! as IType].adventages_program.adventages_array) && <imports.Advantages data={{
                            title: 'Преимущества',
                            values: JSON.parse((datas as any)[program! as IType].adventages_program.adventages_array),
                        }} />}


                        {(datas as any)[program! as IType].results.withPhotos != '' && <imports.Results data={{
                            title: 'Что получите?',
                            withPhotos: (datas as any)[program! as IType].results.withPhotos ? JSON.parse((datas as any)[program! as IType].results.withPhotos) : '',
                            withOutPhotos: (datas as any)[program! as IType].results.withOutPhotos ? JSON.parse((datas as any)[program! as IType].results.withOutPhotos) : '',
                        }} />}

                        {(datas as any)[program! as IType].road_map?.road_map_array && <imports.Roadmap data={{
                            title: 'Ваша дорожная карта',
                            values: JSON.parse((datas as any)[program! as IType].road_map.road_map_array),
                        }} />}

                        <imports.Additionalinfo data={{ values: (datas as any)[program! as IType].dop_info }} />

                        <imports.Questions data={{
                            title: 'Часто задаваемые вопросы',
                            values: JSON.parse((datas as any)[program! as IType].faq.faq_array),
                        }} />
                    </main>
                    <imports.Feedback data={(datas as any)[program! as IType].feedback_form} />
                </>
                :
                <NotFoundPage />
        );
    }
}

export default ProgramTemplate;
